import { useCallback } from 'react';
type ShareOptions = {
  title?: string;
  text?: string;
  imageUrl?: string;
};
function setShareImage(url: string) {
  let tag = document.querySelector('meta[property="og:image"]') as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', 'og:image');
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', url);
}
export function useWebShare(options?: ShareOptions) {
  const share = useCallback(() => {
    const url = window.location.href;
    if (options?.imageUrl) {
      setShareImage(options.imageUrl);
    }

    // Web Share API
    if (navigator.share) {
      navigator.share({
        title: options?.title ?? document.title,
        text: options?.text,
        url
      }).catch(err => {
        // Ignore user-cancelled share
        if (err?.name !== 'AbortError') {
          console.error(err);
        }
      });
      return;
    }

    // Clipboard fallback
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(() => alert('Link copied to clipboard')).catch(() => window.prompt('Copy this link:', url));
      return;
    }

    // Final fallback
    window.prompt('Copy this link:', url);
  }, [options?.title, options?.text, options?.imageUrl]);
  const canShare = typeof navigator !== 'undefined' && (typeof navigator.share === 'function' || typeof navigator.clipboard?.writeText === 'function');
  return {
    share,
    canShare
  };
}